import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import NavbarLinksAdmin from './NavbarLinksAdmin';
import { SidebarResponsive } from '../sidebar/SidebarResponsive';
import { AppRoute } from '../../routes';

interface NavbarProps {
	brandText: string;
	routes: AppRoute[];
	[x: string]: any;
}

export default function Navbar(props: NavbarProps) {
	const { brandText, routes } = props;
	const mainText = useColorModeValue('navy.700', 'white');
	const secondaryText = useColorModeValue('secondaryGray.700', 'white');

	return (
		<Box
			position='sticky'
			top='0'
			zIndex='10'
			bg='transparent'
			px={{ base: '20px', md: '30px' }}
			pt='16px'
			pb='8px'>
			<Flex w='100%' alignItems='center' justifyContent='space-between' flexWrap='wrap' gap='12px'>
				<Flex align='center'>
					<Box display={{ base: 'block', xl: 'none' }} me='10px'>
						<SidebarResponsive routes={routes} />
					</Box>
					<Box>
						<Breadcrumb>
							<BreadcrumbItem color={secondaryText} fontSize='sm'>
								<BreadcrumbLink href='#' color={secondaryText}>
									Datric
								</BreadcrumbLink>
							</BreadcrumbItem>
							<BreadcrumbItem color={secondaryText} fontSize='sm'>
								<BreadcrumbLink href='#' color={secondaryText}>
									{brandText}
								</BreadcrumbLink>
							</BreadcrumbItem>
						</Breadcrumb>
						<Text color={mainText} fontWeight='bold' fontSize='34px' lineHeight='1.1'>
							{brandText}
						</Text>
					</Box>
				</Flex>
				<NavbarLinksAdmin />
			</Flex>
		</Box>
	);
}
